import React, { useState } from 'react';
import { 
  Dialog, 
  DialogActions, 
  DialogContent, 
  DialogContentText, 
  DialogTitle, 
  TextField, 
  Button 
} from '@mui/material';
import { supabaseAdminClient } from '../../Supabase/supabaseRealtimeClient';
import { sendInvite } from '../../Supabase/supabaseClient';
import { criarSocorrista } from '../../socorristas/api';
import InputMask from 'react-input-mask';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const serviceRoleKey = process.env.REACT_APP_SUPABASE_SERVICE_ROLE_KEY;



interface AddPartnerDialogProps {
  open: boolean;
  onClose: () => void;
  initialData?: {
    empresa: string;
    contato: string;
    email: string;
    telefone: string;
  };
  onSave?: (data: { empresa: string; contato: string; email: string; telefone: string }) => Promise<void>;
  onCreate?: (data: { empresa: string; contato: string; email: string; telefone: string }) => void;
}

const AddPartnerDialog: React.FC<AddPartnerDialogProps> = ({ open, onClose, initialData, onSave, onCreate }) => {
  const [empresa, setEmpresa] = useState(initialData?.empresa || '');
  const [contato, setContato] = useState(initialData?.contato || '');
  const [email, setEmail] = useState(initialData?.email || '');
  const [password, setPassword] = useState('');
  const [emailError, setEmailError] = useState('');
  const [telefone, setTelefone] = useState(initialData?.telefone || '');

  React.useEffect(() => {
    setEmpresa(initialData?.empresa || '');
    setContato(initialData?.contato || '');
    setEmail(initialData?.email || '');
    setTelefone(initialData?.telefone || '');
    setPassword('');
  }, [initialData, open]);

  const validateEmail = (email: string) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  };

  const handleSave = async () => {
    const trimmedEmail = email.trim();
    const registrationPassword = password;

    if (!trimmedEmail || (!initialData && !registrationPassword)) {
      alert("Por favor, preencha todos os campos obrigatórios, incluindo e-mail e senha para novos cadastros.");
      return;
    }

    if (!empresa || !contato || !trimmedEmail || !telefone) {
      alert('Por favor, preencha todos os campos.');
      return;
    }
    if (!validateEmail(trimmedEmail)) {
      setEmailError('Email inválido');
      return;
    }
    setEmailError('');

    // === FLUXO 2: EDIÇÃO DE PARCEIRO ===
    if (onSave) {
      await onSave({ empresa, contato, email: trimmedEmail, telefone });
      return;
    }

    // === FLUXO 1: CRIAÇÃO DE SOCORRISTA ===
    try {
      console.log('[AddPartnerDialog] Verificando existência no Auth:', trimmedEmail);
      
      console.log('[AddPartnerDialog] Criando novo usuário e registro via Function');
      const tableData = {
        nome: contato,
        telefone,
        email: trimmedEmail,
        status: 'Ativo',
        nome_empresa: empresa,
      };
      
      const { user } = await sendInvite(trimmedEmail, registrationPassword, 'socorrista', tableData);
      if (!user) {
        alert('Erro: falha ao criar socorrista via Function.');
        return;
      }

      if (onCreate) {
        onCreate({ empresa, contato, email: trimmedEmail, telefone });
      }
      alert('Socorrista criado com sucesso!');
      onClose();
    } catch (error: any) {
      console.error('Erro ao salvar socorrista:', error);
      alert(`Erro: ${error.message || 'Tente novamente.'}`);
    }
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>{initialData ? 'Editar Parceiro' : 'Adicionar Novo Parceiro'}</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Preencha as informações abaixo para adicionar um novo parceiro.
        </DialogContentText>
        <TextField
          autoFocus
          margin="dense"
          label="Empresa"
          type="text"
          fullWidth
          value={empresa}
          onChange={(e) => setEmpresa(e.target.value)}
        />
        <TextField
          margin="dense"
          label="Nome do socorrista"
          type="text"
          fullWidth
          value={contato}
          onChange={(e) => setContato(e.target.value)}
        />
        <TextField
          margin="dense"
          label="Email"
          type="email"
          fullWidth
          value={email}
          onChange={(e) => {
            setEmail(e.target.value);
            if (!validateEmail(e.target.value)) {
              setEmailError('Email inválido');
            } else {
              setEmailError('');
            }
          }}
          error={!!emailError}
          helperText={emailError}
        />
        {!initialData && (
          <TextField
            margin="normal"
            label="Senha"
            type="password"
            fullWidth
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        )}
        <TextField
          margin="dense"
          label="Telefone"
          type="text"
          fullWidth
          value={telefone}
          onChange={(e) => setTelefone(e.target.value)}
          InputProps={{
            inputComponent: InputMask as any,
            inputProps: {
              mask: '(99) 99999-9999',
              maskChar: null
            }
          }}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          Cancelar
        </Button>
        <Button onClick={handleSave} color="primary" variant="contained" disabled={!!emailError || !email}>
          Salvar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AddPartnerDialog; 
